import { type IEmergencyContact } from "components/CaseManagement/interfaces";
import { STATUS_TYPES } from "components/CaseManagement/constants";

export function getPristineEmergencyContact(): IEmergencyContact {
    return {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        contactRelationshipId: undefined,
        otherRelationship: "",
        status: STATUS_TYPES.ACTIVE
    };
}
